module.exports = __webpack_public_path__ + "media/photo/electrics_bgs-8e91d8bb.jpg";